import React from "react";
import "./Loader.scss";

export default function Loader({ loading = true }) {
	return (
		<div className={`loader-wrapper ${loading ? "" : "loaded"}`}>
			<div class="thunderbolt">
				<div class="shape1"></div>
			</div>
		</div>
	);
}
